import * as React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Card } from '@lightspeed/flame/Card';
import { Flex, Box, flameTheme } from '@lightspeed/flame/Core';
import { Text, TextLink } from '@lightspeed/flame/Text';
import { useDispatch } from 'react-redux';

import { useGetAppDownloadUrl } from 'pages/views/devices/hooks/use-get-app-download-url';
import Client from 'pages/views/devices/socketClient';
import { PLATFORMS } from 'pages/views/devices/types';
import { URL } from 'pages/views/devices/utils/help-urls';
import {
  PROTOCOL,
  PROTOCOL_IFRAME,
  APP_NAME,
  getDetectedPlatform,
} from 'pages/views/devices/utils/helper';

import { SizedImage } from '../device.styles';
import { handleConnect } from '../utils/handle-hub-connect';

const OpenHub: React.FunctionComponent = () => {
  const { appDownloadLinks } = useGetAppDownloadUrl();
  const { platform } = getDetectedPlatform();
  const { colors, fontSizes } = flameTheme;
  const dispatch = useDispatch();

  return (
    <>
      <Card style={{ position: 'relative' }}>
        <Flex backgroundColor={colors.white} alignItems="stretch">
          <Flex
            flexDirection="column"
            alignItems="flex-start"
            maxWidth="45%"
            pl={7}
            pb={7}
            pt={7}
            pr={3}
          >
            <Text
              mb={1}
              color={colors['gray-850']}
              fontWeight="bold"
              fontSize={fontSizes['text-xl']}
            >
              Install {APP_NAME}
            </Text>
            <Text mb={1} color={colors['gray-850']} fontSize={fontSizes.text}>
              Set up and manage your printers and Customer Facing Display all in one place.
            </Text>
            <TextLink
              color={colors['blue-500']}
              href={URL.ABOUT_HUB}
              fontWeight="bold"
              target="_blank"
              fontSize={fontSizes.text}
            >
              Learn more
            </TextLink>
            <Flex justifyContent="center" mt={3} mb={2}>
              <Button
                fill
                maxWidth="205px"
                width="100%"
                variant="secondary"
                style={{ color: 'white' }}
                target={PROTOCOL_IFRAME}
                href={appDownloadLinks?.[platform as PLATFORMS]}
                download
                onClick={() =>
                  dispatch({
                    type: 'HUB_UPDATE_DOWNLOAD_STATUS',
                    payload: { hasStartedHubDownload: true },
                  })
                }
              >
                <Text>Download {APP_NAME}</Text>
              </Button>
            </Flex>
            <Flex fontSize={fontSizes.text} flexWrap="wrap">
              <Text mr={1} color={colors.textDimmed}>
                Already have the app installed?
              </Text>
              <TextLink
                fontWeight="bold"
                onClick={handleConnect}
                href={`${PROTOCOL}${Client.getCFDParams()}`}
                target={PROTOCOL_IFRAME}
                data-test="open-app-link"
              >
                Open {APP_NAME}.
              </TextLink>
            </Flex>
          </Flex>
          <Box style={{ flex: '0 1 auto' }}>
            <SizedImage
              alt="Man standing in front of a Customer Facing Display"
              src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/cfd/marketing-cfd-wave.png"
            />
          </Box>
        </Flex>
      </Card>
    </>
  );
};

export { OpenHub };
